import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

function Addons() {
  const { company_id, app_id, app_creator_app_id } = useParams()
  const navigate = useNavigate()

  // Construct iframe URL based on params (change domain/path as needed)
  const iframeUrl = `https://apps.alltheapps.io/${company_id}/${app_id}/app_creator/${app_creator_app_id}`
  return (
    <>
      <MDBox mb={2}>
        <MDButton
          variant="gradient"
          color="dark"
          sx={{ height: '100%' }}
          onClick={() => navigate(-1)}
        >
          Go Back
        </MDButton>
      </MDBox>
      <div>
        <h1>Addons</h1>
        {/* <p>All Addons</p> */}
        <iframe
          src={iframeUrl}
          title="Addons Iframe"
          style={{ width: '100%', height: '70vh', border: 'none' }}
        ></iframe>
      </div>
    </>
  )
}

export default Addons
